// Overgezet uit naslag/server/server/generateData/tasksPerCategory/AssetData.ts.
import { TaskType } from '../../types/tasks.js';
import { InGameEffect } from '../../types/inGameEffect.js';
const effects = [
    {
        type: InGameEffect.assetData,
        description: 'Ga naar de volgende diepte in je Asset Data sheet',
    },
];
export const AssetDataTaken = [
    {
        _id: 'assetData0',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 500,
        description: 'Ontdek de namen van je assets',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'assetData1',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 500,
        description: 'Krijg inzicht waar je storingen plaatsvinden',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'assetData2',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 1000,
        description: 'Krijg zicht op impact van assets en onderdelen',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'assetData3',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 1000,
        description: 'Ontdek de impact van storingen op de assets',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'assetData4',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 1500,
        description: 'Scherp het detailniveau aan',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
    {
        _id: 'assetData5',
        type: TaskType.assetData,
        title: 'Asset Data',
        cost: 1500,
        description: 'Scherp het detailniveau aan',
        inGameEffectDescription: 'Ga naar de volgende diepte in je Asset Data sheet',
        inGameEffect: [InGameEffect.assetData],
        needsSparepart: false,
        needsMechanic: false,
        taskEffects: effects,
    },
];
